import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDateStruct, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ToastService } from '../../Util/Toast/toast.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-attendance-summary',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, LoaderComponent, DataTablesModule],
  templateUrl: './attendance-summary.component.html',
  styleUrl: './attendance-summary.component.scss'
})
export class AttendanceSummaryComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  public User: any = null;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();
  AttendanceSummary: any[] = []
  selectedMonth: any = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };
  currentDate: Date = new Date();
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  selectedMonthFormatted: any = null
  dtoptions: DataTables.Settings = {};
  constructor(public activeModal: NgbActiveModal,
    private toast: ToastService,
    private support: SupportTicketService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sessionService: SessionService,
    private utility: UtilityService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();

    const prevMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
    this.minDate = { year: prevMonth.getFullYear(), month: prevMonth.getMonth() + 1, day: prevMonth.getDate() };

    const lastDayOfCurrentMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
    this.maxDate = { year: lastDayOfCurrentMonth.getFullYear(), month: lastDayOfCurrentMonth.getMonth() + 1, day: lastDayOfCurrentMonth.getDate() };
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    if (this.InputData.IsDate) {
      this.updateFormattedMonthYear();
      //this.getData1();
    }
    //else {
      this.getData();
    //}
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  onNavigate() {
    this.AttendanceSummary = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.updateFormattedMonthYear();
  }
  updateFormattedMonthYear() {
    if (this.selectedMonth && this.selectedMonth.year && this.selectedMonth.month) {
      const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
      this.selectedMonthFormatted = new Intl.DateTimeFormat('en-US', options).format(startFromDate);
    }
  }
  getData() {
    this.isDisabled = true;
    this.support.EmployeePayslipSummary({ SelectType: 'Attendance', EmpMasterId: this.InputData.EmpMasterId, MonthYear:this.InputData.IsDate? this.selectedMonthFormatted: this.InputData.MonthYear }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.AttendanceSummary = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }
  // getData1() {
  //   this.isDisabled = true;
  //   this.support.EmployeePayslipSummary({ SelectType: 'Attendance', EmpMasterId: this.InputData.EmpMasterId, MonthYear: this.selectedMonthFormatted }).subscribe({
  //     next: (response) => {
  //       if (response.Table) {
  //         this.AttendanceSummary = Object.values(response.Table);
  //         this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //           dtInstance.destroy();
  //           this.dtTrigger.next(null);
  //         });
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //       return true
  //     },
  //     error: (err) => {
  //       this.isDisabled = false;
  //       return false;
  //     }
  //   })
  // }
  Cancel() {
    this.activeModal.close();
  }
  onchange() {
    //this.AttendanceSummary = Object.values([])
    this.AttendanceSummary = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
